import React from "react";

const CustomerWatchHistoryTab = ({ customerId }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6 font-outfit">
      <h2 className="text-xl font-semibold mb-4 font-outfit text-gray-800">
        Customer Watch History
      </h2>

      {/* Watch history content */}
      <div className="space-y-6">
        {/* Watch history will be implemented here */}
        <p className="text-gray-600 font-outfit">
          Watch history content will be displayed here.
        </p>
      </div>
    </div>
  );
};

export default CustomerWatchHistoryTab;
